import {compose, legacy_createStore as createStore, Store} from "redux";
import {reducers, RootState} from "../reducer"; // Assuming you are using combineReducers
import {THEME_CONFIG} from "@/configs/ThemeConfig";

const preloadedState: RootState = {
    theme: THEME_CONFIG,  // Ensure THEME_CONFIG is of type ThemeState
};
  
// Optionally, provide a default (preloaded) state with the correct shape
const configureStore = (preloadedState?: RootState): Store<RootState> => {
    const composeEnhancers = compose;
    const store = createStore(reducers, preloadedState, composeEnhancers());

    return store;
};

// If you want to pass in an initial state, you can do it here
const store = configureStore(preloadedState); // or configureStore(preloadedState);

export default store;
